// extracted by mini-css-extract-plugin
export default {"datePickerPaper":"DatePicker-module__datePickerPaper--_MSXM"};